type VoidFn = () => void;

let onUnauthorized: VoidFn | null = null;

/** Called from api client when an authenticated request gets 401 (e.g. expired JWT). */
export function notifySessionUnauthorized(): void {
  try {
    onUnauthorized?.();
  } catch {
    // ignore
  }
}

/** Register handler (typically logout). Returns unregister function. */
export function registerSessionUnauthorizedHandler(fn: VoidFn): () => void {
  onUnauthorized = fn;
  return () => {
    onUnauthorized = null;
  };
}
